export const useFeatureFlag = (feature: string) => {
  const featureFlags = window.__FEATURE_FLAGS__ || [];
  const featureFlag = featureFlags.find((f) => f.name === feature);
  return featureFlag?.enabled;
};
